export const getPaperPositions = (state) => state.paperPositions;
